Vue.filter('capitalize', require('./capitalize').default);
Vue.filter('date', require('./date').default);
Vue.filter('fromNow', require('./fromNow').default);
Vue.filter('interval', require('./interval').default);
